import ContentLoader from 'react-content-loader'
import React from 'react'

const LoadingSkeleton = () => (
  <ContentLoader className="schedule-guage__skeleton-container">
    <rect height="100" rx="0" ry="0" width="100" x="0" y="0" />
  </ContentLoader>
)

export default LoadingSkeleton
